import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterdata'
})
export class FilterdataPipe implements PipeTransform {

  transform(IndustryCopy: any[], filter: string): any {
    if (!filter) {
      return IndustryCopy;
    }
    filter = filter.replace(/^(.)|\s+(.)/g, c => c.toUpperCase());
    var result=IndustryCopy.filter(item => item.industryName.startsWith(filter) ==true).slice(0,5);
    return result;
  }

}
